import React from "react";
import { Box, Typography } from "@mui/material";
import { useCountdown } from "../../../../hooks/useCountDown";
import { startOfTomorrow } from "date-fns";
import { INVITATION_TYPES, Invitations } from "../../../../store/services/invitations/dto/invitations.dto";
import { LANG_AR, RTL } from "../constants";
import { convertDigitsToArabicNumerals } from "../../../../utils/formatNumbersToArabic";

const CountDown = ({
	data,
	daysString,
	hoursString,
	minutesString,
	secondsString
}: {
	data: Invitations;
	daysString: string;
	hoursString: string;
	minutesString: string;
	secondsString: string;
}) => {
	const isTemplate = data?.type === INVITATION_TYPES.TEMPLATE;
	const { days, hours, minutes, seconds } = useCountdown(
		isTemplate ? startOfTomorrow().toISOString() : (data?.wedding_date as string)
	);
	const getLocalisedNumber = (number: number, language: string) => {
		if (language === LANG_AR) {
			return convertDigitsToArabicNumerals("" + number);
		}
		return number;
	};

	return (
		<Box className={`counter_boxes_wrapper ${data?.language === LANG_AR && RTL}`}>
			<Box className={"counter_box_wrapper"}>
				<Box className={"counter_box"}>{getLocalisedNumber(days, data?.language)}</Box>
				<Typography>{daysString}</Typography>
			</Box>
			<Box className={"counter_box_wrapper"}>
				<Box className={"counter_box"}>{getLocalisedNumber(hours, data?.language)}</Box>
				<Typography>{hoursString}</Typography>
			</Box>
			<Box className={"counter_box_wrapper"}>
				<Box className={"counter_box"}>{getLocalisedNumber(minutes, data?.language)}</Box>
				<Typography>{minutesString}</Typography>
			</Box>
			<Box className={"counter_box_wrapper"}>
				<Box className={"counter_box"}>{getLocalisedNumber(seconds, data?.language)}</Box>
				<Typography>{secondsString}</Typography>
			</Box>
		</Box>
	);
};

export default CountDown;
